import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-professional-bodies-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-professional-bodies-bpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { CreateApplicationProfessionalBodiesBpamsConstants } from "./create-application-professional-bodies-bpams.constants";
import { AlertType } from "../../../../shared/models/alert";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { take } from "rxjs/operators";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { forkJoin } from "rxjs";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationProfessionalBodiesBpamsComponent = class CreateApplicationProfessionalBodiesBpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    recipientService;
    userInformationService;
    aflaModuleStrategyService;
    selectedApplicationService;
    changeDetectorRef;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    architectRecipientComponent;
    engineerRecipientComponent;
    contractorRecipientComponent;
    fireConsultantRecipientComponent;
    otherProfessionalRecipientComponent;
    professionalBodiesForm;
    professionalBodiesFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.PROFESSIONAL_BODY_FORM_CONTROL_NAME;
    markArchitectAsRequiredLabel = CreateApplicationProfessionalBodiesBpamsConstants.MARK_ARCHITECT_AS_REQUIRED_LABEL;
    markArchitectAsRequiredFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.MARK_ARCHITECT_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToArchitectLabel = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_ARCHITECT_LABEL;
    copyApplicantDetailsToArchitectFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_ARCHITECT_FORM_CONTROL_NAME;
    markEngineerAsRequiredLabel = CreateApplicationProfessionalBodiesBpamsConstants.MARK_ENGINEER_REQUIRED_LABEL;
    markEngineerAsRequiredFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    copyApplicantDetailsToElectricalContractorFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    markElectricalContractorAsRequiredLabel = CreateApplicationProfessionalBodiesBpamsConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL;
    markElectricalContractorAsRequiredFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    copyApplicantDetailsToEngineerFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    markFireConsultantAsRequiredLabel = CreateApplicationProfessionalBodiesBpamsConstants.MARK_FIRE_CONSULTANT_AS_REQUIRED_LABEL;
    markFireConsultantAsRequiredFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToFireConsultantLabel = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_LABEL;
    copyApplicantDetailsToFireConsultantFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_FORM_CONTROL_NAME;
    markOtherProfessionalAsRequiredLabel = CreateApplicationProfessionalBodiesBpamsConstants.MARK_OTHER_PROFESSIONAL_AS_REQUIRED_LABEL;
    markOtherProfessionalAsRequiredFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToOtherProfessionalLabel = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_LABEL;
    copyApplicantDetailsToOtherProfessionalFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    architectFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.ARCHITECT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    fireConsultantFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.FIRE_CONSULTANT_FORM_CONTROL_NAME;
    otherProfessionalFormControlName = CreateApplicationProfessionalBodiesBpamsConstants.OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    showArchitect = false;
    showEngineer = false;
    showElectricalContractor = false;
    showSACAPOptions = false;
    showFireConsultant = false;
    showOtherProfessional = false;
    showArchitectRequiredCheckbox = true;
    architectDisableFilterBy = true;
    architectDisableEditing = false;
    architectShowFields = true;
    architectGroups = [];
    architectLabel = CreateApplicationProfessionalBodiesBpamsConstants.ARCHITECT_LABEL;
    architectShowGroupsDropdown = false;
    architectIsRequiredChecked = false;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = CreateApplicationProfessionalBodiesBpamsConstants.ENGINEER_LABEL;
    engineerShowGroupsDropdown = false;
    engineerIsRequiredChecked = false;
    fireConsultantDisableFilterBy = true;
    fireConsultantDisableAdd = true;
    fireConsultantDisableEditing = false;
    fireConsultantShowFields = true;
    fireConsultantIsInternal = false;
    fireConsultantGroups = [];
    fireConsultantLabel = CreateApplicationProfessionalBodiesBpamsConstants.FIRE_CONSULTANT_LABEL;
    fireConsultantShowGroupsDropdown = false;
    fireConsultantIsRequiredChecked = false;
    otherProfessionalDisableFilterBy = true;
    otherProfessionalDisableAdd = true;
    otherProfessionalDisableEditing = false;
    otherProfessionalShowFields = true;
    otherProfessionalIsInternal = false;
    otherProfessionalGroups = [];
    otherProfessionalLabel = CreateApplicationProfessionalBodiesBpamsConstants.OTHER_PROFESSIONAL_LABEL;
    otherProfessionalShowGroupsDropdown = false;
    otherProfessionalIsRequiredChecked = false;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = CreateApplicationProfessionalBodiesBpamsConstants.ELECTRICAL_CONTRACTOR_LABEL;
    contractorShowGroupsDropdown = false;
    contractorIsRequiredChecked = false;
    applicant;
    componentName = CreateApplicationProfessionalBodiesBpamsConstants.COMPONENT_NAME;
    savedArchitect = [];
    savedEngineer = [];
    savedFireConsultant = [];
    savedOtherProfessional = [];
    savedContractor = [];
    authUserDetails;
    applicationCreateServiceSubscription;
    constructor(applicationCreateService, recipientService, userInformationService, aflaModuleStrategyService, selectedApplicationService, changeDetectorRef, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.recipientService = recipientService;
        this.userInformationService = userInformationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRef = changeDetectorRef;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
        this.getApplicantData();
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.initialiseDefaultValues();
        this.subscribeToCheckFormValidity();
        this.getAuthUserInformation();
    }
    loadMetadata(stepMeta) {
        try {
            this.architectGroups = stepMeta.architectGroup;
            this.engineerGroups = stepMeta.engineerGroup;
            this.contractorGroups = stepMeta.electricalContractorGroup;
            this.fireConsultantGroups = stepMeta.fireConsultantGroup;
            this.otherProfessionalGroups = stepMeta.otherProfessionalGroup;
            this.showSACAPOptions = stepMeta.enableSACAPLookup;
            if (this.showSACAPOptions) {
                this.configureProfBodiesForSACAP();
            }
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.professionalBodiesFormControlName);
        form.clearValidators();
        form.updateValueAndValidity();
        this.professionalBodiesForm = form;
    }
    onMarkArchitectAsRequired(event) {
        const architectIsRequired = event.target.checked;
        if (architectIsRequired) {
            this.showArchitect = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.architectFormControlName).enable();
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(true);
            this.architectIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            this.professionalBodiesForm.get(this.architectFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.architectFormControlName).disable();
            this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(false);
            this.showArchitect = false;
            this.changeDetectorRefs.detectChanges();
            this.architectIsRequiredChecked = false;
        }
    }
    onMarkEngineerAsRequired(event) {
        const engineerIsRequired = event.target.checked;
        if (engineerIsRequired) {
            this.showEngineer = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.engineerFormControlName).enable();
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(true);
            this.engineerIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.engineerFormControlName).disable();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
            this.showEngineer = false;
            this.changeDetectorRefs.detectChanges();
            this.engineerIsRequiredChecked = false;
        }
    }
    onMarkFireConsultantAsRequired(event) {
        const fireConsultantIsRequired = event.target.checked;
        if (fireConsultantIsRequired) {
            this.showFireConsultant = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).enable();
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(true);
            this.fireConsultantIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).disable();
            this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(false);
            this.showFireConsultant = false;
            this.changeDetectorRefs.detectChanges();
            this.fireConsultantIsRequiredChecked = false;
        }
    }
    onMarkOtherProfessionalAsRequired(event) {
        const otherProfessionalIsRequired = event.target.checked;
        if (otherProfessionalIsRequired) {
            this.showOtherProfessional = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).enable();
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(true);
            this.otherProfessionalIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).disable();
            this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(false);
            this.showOtherProfessional = false;
            this.changeDetectorRefs.detectChanges();
            this.otherProfessionalIsRequiredChecked = false;
        }
    }
    onMarkElectricalContractorAsRequired(event) {
        const contractorIsRequired = event.target.checked;
        if (contractorIsRequired) {
            this.showElectricalContractor = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.contractorFormControlName).enable();
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
            this.contractorIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.contractorFormControlName).disable();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
            this.showElectricalContractor = false;
            this.changeDetectorRefs.detectChanges();
            this.contractorIsRequiredChecked = false;
        }
    }
    onCopyApplicantToArchitect($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.architect > 0 && this.selectedApplication.architect[0].id >= 0) ? this.selectedApplication.architect[0].id : 0;
            applicantData.groups = this.architectGroups;
            this.professionalBodiesForm.get(this.architectFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
        }
    }
    onCopyApplicantToEngineer($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.engineer > 0 && this.selectedApplication.engineer[0].id >= 0) ? this.selectedApplication.engineer[0].id : 0;
            applicantData.groups = this.engineerGroups;
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
        }
    }
    onCopyApplicantToFireConsultant($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.fireConsultant > 0 && this.selectedApplication.fireConsultant[0].id >= 0) ? this.selectedApplication.fireConsultant[0].id : 0;
            applicantData.groups = this.fireConsultantGroups;
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
        }
    }
    onCopyApplicantToOtherProfessional($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.otherProfessional > 0 && this.selectedApplication.otherProfessional[0].id >= 0) ? this.selectedApplication.otherProfessional[0].id : 0;
            applicantData.groups = this.otherProfessionalGroups;
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
        }
    }
    onCopyApplicantToElectricalContractor($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.electricalContractor > 0 && this.selectedApplication.electricalContractor[0].id >= 0) ? this.selectedApplication.electricalContractor[0].id : 0;
            applicantData.groups = this.engineerGroups;
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
        }
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateServiceSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.professionalBodiesForm && this.professionalBodiesFormControlName === formGroupName) {
                    if (this.showArchitect) {
                        this.architectRecipientComponent.markFormControlsAsTouched();
                        if (this.showSACAPOptions) {
                            const sacapno = this.professionalBodiesForm.get(this.architectFormControlName).value.sacapRegistrationNumber;
                            if (!sacapno) {
                                this.appController.showMessage("Please verify architect before continuing to the next step", AlertType.Warning);
                            }
                            const sacapverified = this.professionalBodiesForm.get(this.architectFormControlName).value.sacapRegistrationNumberVerified;
                            if (!sacapverified) {
                                this.appController.showMessage("Architect needs to be registered with SACAP. Please enter a valid SACAP registration number", AlertType.Warning);
                            }
                        }
                    }
                    if (this.showEngineer) {
                        this.engineerRecipientComponent.markFormControlsAsTouched();
                    }
                    if (this.showFireConsultant) {
                        this.fireConsultantRecipientComponent.markFormControlsAsTouched();
                    }
                    if (this.showOtherProfessional) {
                        this.otherProfessionalRecipientComponent.markFormControlsAsTouched();
                    }
                    if (this.showElectricalContractor) {
                        this.contractorRecipientComponent.markFormControlsAsTouched();
                    }
                    this.changeDetectorRef.detectChanges();
                }
            }
        });
    }
    syncProfBodiesIsRequiredCheckBoxes(selectedApplication) {
        this.syncArchitectIsRequiredCheckBoxes(selectedApplication);
        this.syncEngineerIsRequiredCheckBoxes(selectedApplication);
        this.syncElectricalConstructorIsRequiredCheckBoxes(selectedApplication);
        this.syncFireConsultantIsRequiredCheckBoxes(selectedApplication);
        this.syncOtherProfessionalIsRequiredCheckBoxes(selectedApplication);
        this.professionalBodiesForm.markAsDirty();
        this.changeDetectorRefs.detectChanges();
    }
    syncArchitectIsRequiredCheckBoxes(selectedApplication) {
        const architectNotApplicable = selectedApplication?.architectNa;
        if (architectNotApplicable) {
            this.architectIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            this.professionalBodiesForm.get(this.architectFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.architectFormControlName).disable();
            this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(false);
            this.showArchitect = false;
        }
        else {
            this.showArchitect = true;
            this.architectIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(true);
        }
    }
    syncEngineerIsRequiredCheckBoxes(selectedApplication) {
        const engineerIsNotApplicable = selectedApplication?.engineerNa;
        if (engineerIsNotApplicable) {
            this.architectIsRequiredChecked = false;
            this.showEngineer = false;
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.engineerFormControlName).disable();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showEngineer = true;
            this.engineerIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(true);
        }
    }
    syncFireConsultantIsRequiredCheckBoxes(selectedApplication) {
        const fireConsultantIsNotApplicable = selectedApplication?.fireConsultantNa;
        if (fireConsultantIsNotApplicable) {
            this.fireConsultantIsRequiredChecked = false;
            this.showFireConsultant = false;
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).disable();
            this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showFireConsultant = true;
            this.fireConsultantIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(true);
        }
    }
    syncOtherProfessionalIsRequiredCheckBoxes(selectedApplication) {
        const otherProfessionalIsNotApplicable = selectedApplication?.otherProfessionalNa;
        if (otherProfessionalIsNotApplicable) {
            this.otherProfessionalIsRequiredChecked = false;
            this.showOtherProfessional = false;
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).disable();
            this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showOtherProfessional = true;
            this.otherProfessionalIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(true);
        }
    }
    syncElectricalConstructorIsRequiredCheckBoxes(selectedApplication) {
        const electricalContractorIsNotApplicable = selectedApplication?.electricalContractorNa;
        if (electricalContractorIsNotApplicable) {
            this.contractorIsRequiredChecked = false;
            this.showElectricalContractor = false;
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.contractorFormControlName).disable();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showElectricalContractor = true;
            this.contractorIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
        }
    }
    populateProfessionalBodiesForms() {
        const selectedApplication = this.selectedApplication;
        this.populateArchitect(selectedApplication);
        this.populateEngineer(selectedApplication);
        this.populateElectricalContractor(selectedApplication);
        this.populateFireConsultant(selectedApplication);
        this.populateOtherProfessional(selectedApplication);
    }
    populateArchitect(selectedApplication) {
        const architectControl = this.professionalBodiesForm.get(this.architectFormControlName);
        if (selectedApplication.architectNa) {
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            this.showArchitect = false;
            this.architectIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showArchitect = true;
            this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(true);
            this.architectIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.architectFormControlName).reset();
            if (this.savedArchitect.length > 0) {
                const architect = this.savedArchitect[0];
                architect.groups = this.architectGroups;
                architect.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                architectControl.setValue(architect);
            }
        }
    }
    populateEngineer(selectedApplication) {
        const engineerControl = this.professionalBodiesForm.get(this.engineerFormControlName);
        if (selectedApplication.engineerNa) {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.showEngineer = false;
            this.engineerIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showEngineer = true;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
            this.engineerIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            if (this.savedEngineer.length > 0) {
                const engineer = this.savedEngineer[0];
                engineer.groups = this.engineerGroups;
                engineer.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                engineerControl.setValue(engineer);
            }
        }
    }
    populateFireConsultant(selectedApplication) {
        const fireConsultantControl = this.professionalBodiesForm.get(this.fireConsultantFormControlName);
        if (selectedApplication.fireConsultantNa) {
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            this.showFireConsultant = false;
            this.fireConsultantIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showFireConsultant = true;
            this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(true);
            this.fireConsultantIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.fireConsultantFormControlName).reset();
            if (this.savedFireConsultant.length > 0) {
                const fireConsultant = this.savedFireConsultant[0];
                fireConsultant.groups = this.fireConsultantGroups;
                fireConsultant.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                fireConsultantControl.setValue(fireConsultant);
            }
        }
    }
    populateOtherProfessional(selectedApplication) {
        const otherProfessionalControl = this.professionalBodiesForm.get(this.otherProfessionalFormControlName);
        if (selectedApplication.otherProfessionalNa) {
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            this.showOtherProfessional = false;
            this.otherProfessionalIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showOtherProfessional = true;
            this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(true);
            this.otherProfessionalIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.otherProfessionalFormControlName).reset();
            if (this.savedOtherProfessional.length > 0) {
                const otherProfessional = this.savedOtherProfessional[0];
                otherProfessional.groups = this.otherProfessionalGroups;
                otherProfessional.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                otherProfessionalControl.setValue(otherProfessional);
            }
        }
    }
    populateElectricalContractor(selectedApplication) {
        const electricalContractorControl = this.professionalBodiesForm.get(this.contractorFormControlName);
        if (selectedApplication.electricalContractorNa) {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.showElectricalContractor = false;
            this.contractorIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showElectricalContractor = true;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
            this.contractorIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            if (this.savedContractor.length > 0) {
                const electricalContractor = this.savedContractor[0];
                electricalContractor.groups = this.contractorGroups;
                electricalContractor.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                electricalContractorControl.setValue(electricalContractor);
            }
        }
    }
    getProfBodiesData() {
        if (this.selectedApplication) {
            const architectID = this.selectedApplication.architectId;
            const engineerID = this.selectedApplication.engineerId;
            const contractorID = this.selectedApplication.electricalContractorId;
            const fireConsultantID = this.selectedApplication.fireConsultantId;
            const otherProfessionalID = this.selectedApplication.otherProfessionalId;
            if (architectID || engineerID || contractorID) {
                this.getProfessionalBodiesId(architectID, engineerID, contractorID, fireConsultantID, otherProfessionalID);
            }
            if (!architectID) {
                this.getArchitectDataFromUserSettings();
            }
        }
    }
    getProfessionalBodiesId(architectID, engineerID, contractorID, fireConsultantID, otherProfessionalID) {
        const architectAgentParams = {
            $expand: "groups", $filter: `id eq ${architectID}`
        };
        const engineerParams = {
            $expand: "groups", $filter: `id eq ${engineerID}`
        };
        const contractorParams = {
            $expand: "groups", $filter: `id eq ${contractorID}`
        };
        const fireConsultantParams = {
            $expand: "groups", $filter: `id eq ${fireConsultantID}`
        };
        const otherProfessionalParams = {
            $expand: "groups", $filter: `id eq ${otherProfessionalID}`
        };
        forkJoin([this.recipientService.getRecipientsObservable(architectAgentParams), this.recipientService.getRecipientsObservable(engineerParams), this.recipientService.getRecipientsObservable(contractorParams), this.recipientService.getRecipientsObservable(fireConsultantParams), this.recipientService.getRecipientsObservable(otherProfessionalParams)]).subscribe({
            next: (professionalBodies) => {
                if (professionalBodies[0]?.length > 0) {
                    // implementingAgent
                    this.savedArchitect = professionalBodies[0];
                }
                else {
                    this.getArchitectDataFromUserSettings();
                }
                if (professionalBodies[1]?.length > 0) {
                    // Engineer
                    this.savedEngineer = professionalBodies[1];
                }
                if (professionalBodies[2]?.length > 0) {
                    // contractor
                    this.savedContractor = professionalBodies[2];
                }
                if (professionalBodies[3]?.length > 0) {
                    //fireConsultant
                    this.savedFireConsultant = professionalBodies[3];
                }
                if (professionalBodies[4]?.length > 0) {
                    //otherProfessional
                    this.savedOtherProfessional = professionalBodies[4];
                }
                if (this.professionalBodiesForm.pristine || professionalBodies.length > 0) {
                    this.syncProfBodiesIsRequiredCheckBoxes(this.selectedApplication);
                    this.populateProfessionalBodiesForms();
                }
                else {
                    this.showProfBodiesBasedOnCurrentFormStatus();
                }
                this.changeDetectorRefs.detectChanges();
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    showProfBodiesBasedOnCurrentFormStatus() {
        const architectIsRequired = this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).value;
        const engineerIsRequired = this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).value;
        const contractorIsRequired = this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).value;
        if (architectIsRequired) {
            this.showArchitect = true;
        }
        else {
            this.showArchitect = false;
        }
        if (engineerIsRequired) {
            this.showEngineer = true;
        }
        else {
            this.showEngineer = false;
        }
        if (contractorIsRequired) {
            this.showElectricalContractor = true;
        }
        else {
            this.showElectricalContractor = false;
        }
    }
    getApplicantData() {
        if (this.selectedApplication) {
            const applicantID = this.selectedApplication.applicantId;
            if (applicantID) {
                this.getApplicantByApplicantId(applicantID);
            }
        }
    }
    getApplicantByApplicantId(applicantID) {
        const params = {
            $expand: "groups", $filter: `id eq ${applicantID}`
        };
        this.recipientService.getRecipientsObservable(params).pipe(take(1)).subscribe({
            next: (recipients) => {
                if (recipients.length > 0) {
                    const savedApplicant = recipients[0];
                    this.applicant = savedApplicant;
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    initialiseDefaultValues() {
        this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markFireConsultantAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markOtherProfessionalAsRequiredFormControlName).setValue(false);
    }
    getAuthUserInformation() {
        this.userInformationService.$authenticatedUser.subscribe({
            next: (authUSer) => {
                this.authUserDetails = authUSer;
                this.getProfBodiesData();
            }
        });
    }
    getArchitectDataFromUserSettings() {
        const authUserId = this.authUserDetails.id;
        this.recipientService.getApplicantDataFromUserSettings(authUserId, "portal_architect").subscribe({
            next: (userSettingList) => {
                if (userSettingList.length > 0) {
                    const userSettingData = userSettingList[0];
                    const recipientData = JSON.parse(userSettingData.value);
                    recipientData.moduleId = Number(this.appController.selectedModuleID);
                    recipientData.jobId = Number(this.jobId);
                    this.showArchitect = true;
                    this.architectIsRequiredChecked = true;
                    this.changeDetectorRefs.detectChanges();
                    this.professionalBodiesForm.get(this.architectFormControlName).enable();
                    this.professionalBodiesForm.get(this.architectFormControlName).reset();
                    this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(true);
                    this.professionalBodiesForm.get(this.architectFormControlName).setValue(recipientData);
                    this.changeDetectorRef.detectChanges();
                }
            }, error: (err) => {
                this.appController.handleServerErrorMessage("user settings", err, CRUDOperation.Get);
            }
        });
    }
    configureProfBodiesForSACAP() {
        this.showArchitect = true;
        this.professionalBodiesForm.get(this.markArchitectAsRequiredFormControlName).setValue(true);
        this.professionalBodiesForm.get(this.architectFormControlName).enable();
        const copyControl = this.professionalBodiesForm.get(this.copyApplicantDetailsToArchitectFormControlName);
        copyControl.enable();
        this.showArchitectRequiredCheckbox = false;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientService },
        { type: UserInformationService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        architectRecipientComponent: [{ type: ViewChild, args: ["architectRecipientComponent", { static: false },] }],
        engineerRecipientComponent: [{ type: ViewChild, args: ["engineerRecipientComponent", { static: false },] }],
        contractorRecipientComponent: [{ type: ViewChild, args: ["contractorRecipientComponent", { static: false },] }],
        fireConsultantRecipientComponent: [{ type: ViewChild, args: ["fireConsultantRecipientComponent", { static: false },] }],
        otherProfessionalRecipientComponent: [{ type: ViewChild, args: ["otherProfessionalRecipientComponent", { static: false },] }]
    };
};
CreateApplicationProfessionalBodiesBpamsComponent = __decorate([
    Component({
        selector: "app-create-application-professional-bodies-bpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationProfessionalBodiesBpamsComponent);
export { CreateApplicationProfessionalBodiesBpamsComponent };
